import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import { AddIcon } from '../../../../images/icons/WrapSvg';
import Rule from './Rule';

class Elaboration extends React.Component {
    state = {
        datospreparacion: [],
        id: '',
    };

    static getDerivedStateFromProps(props, state) {
        const { product, id, datospreparacion } = props;
        console.log(state.datospreparacion, datospreparacion);
        if ((product && id !== state.id) || datospreparacion !== state.datospreparacion) {
            state.id = id;
            state.datospreparacion = datospreparacion ? datospreparacion : [];
            return state;
        }
        return null;
    }

    handleClick = (event) => {
        this.props.onAdd();
    };

    handleDelete = (index) => {
        const { datospreparacion } = this.state;
        if (datospreparacion.length > index) {
            this.props.onDelete(index);
        }
    };

    render() {
        const { intl } = this.props;
        const { datospreparacion } = this.state;

        if (!datospreparacion || datospreparacion.length === 0) {
            return (
                <div
                    onClick={this.handleClick}
                    className="flex_full_row margin_bottom_5 margin_top_12 padding_borders elements_center align_center barlow_medium_place_holder c_bluish uppercase dottedBox hand"
                >
                    <span>
                        <FormattedMessage id="recipe_add_elaboration" />
                    </span>
                    <AddIcon color="primary" className="icon" />
                </div>
            );
        } else {
            return (
                <Card className={'product_card margin_top_12'}>
                    <CardContent>
                        <Grid container justify="center" className={'flex_grow_1 margin_top_24'}>
                            <Grid item xs={3} className="">
                                <div className="barlow_regular_small c_slate_grey upper margin_right_18 margin_top_12 text_align_right ">
                                    {intl.formatMessage({ id: 'recipe_rules_preparation' })}
                                </div>
                            </Grid>
                            <Grid item xs={9} className="">
                                <div className="flex_full_column">
                                    <div className="flex_full_row margin_bottom_12">
                                        <Grid
                                            container
                                            justify="center"
                                            className={'flex_grow_1 margin_top_24'}
                                        >
                                            <Grid
                                                item
                                                xs={1}
                                                className="padding_top_12 barlow_regular_small upper bg_greyish_brown shadow_down_only"
                                            />
                                            <Grid
                                                item
                                                xs={4}
                                                className="padding_top_12 barlow_regular_small upper bg_greyish_brown shadow_down_only"
                                            >
                                                {intl.formatMessage({
                                                    id: 'recipe_time_preparation',
                                                })}
                                            </Grid>
                                            <Grid
                                                item
                                                xs={3}
                                                className="padding_top_12 barlow_regular_small upper bg_greyish_brown shadow_down_only"
                                            >
                                                {intl.formatMessage({
                                                    id: 'recipe_units_producion_from',
                                                })}
                                            </Grid>
                                            <Grid
                                                item
                                                xs={3}
                                                className="padding_top_12 barlow_regular_small upper bg_greyish_brown shadow_down_only"
                                            >
                                                {intl.formatMessage({
                                                    id: 'recipe_units_producion_until',
                                                })}
                                            </Grid>
                                            <Grid
                                                item
                                                xs={1}
                                                className="padding_top_12 barlow_regular_small upper bg_greyish_brown shadow_down_only"
                                            />
                                            {datospreparacion &&
                                                datospreparacion.length > 0 &&
                                                datospreparacion.map((r, index) => {
                                                    return (
                                                        <Rule
                                                            {...this.props}
                                                            key={`preparation-rule-${index}`}
                                                            info={r}
                                                            index={index}
                                                            onChange={this.props.onChange}
                                                            onDelete={this.handleDelete}
                                                        />
                                                    );
                                                })}
                                        </Grid>
                                    </div>
                                    <div className="flex_full_row margin_bottom_12">
                                        <div
                                            onClick={this.handleClick}
                                            className="flex_full_row margin_bottom_5 margin_top_12 padding_borders elements_center align_center barlow_medium_place_holder c_bluish uppercase dottedBox hand"
                                        >
                                            <span>
                                                {intl.formatMessage({ id: 'recipe_add_rule' })}
                                            </span>
                                            <AddIcon color="primary" className="icon" />
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            );
        }
    }
}

Elaboration.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Elaboration);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/recipe/Elaboration.js